module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transferWrap clearfix"
  }, [_c('a', {
    attrs: {
      "href": "https://n.allfootballapp.com/v2/transfer?id=1"
    }
  }, [_c('p', [_c('span', {
    staticClass: "latest"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home/home_icon4.jpg"),
      "alt": "Latest Transfers",
      "title": ""
    }
  })]), _vm._v(" "), _c('b', [_vm._v("Latest")])])]), _vm._v(" "), _c('a', {
    staticClass: "topwrap",
    attrs: {
      "href": "https://n.allfootballapp.com/v2/transfer?id=2"
    }
  }, [_c('p', {
    staticClass: "top_border"
  }, [_c('span', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home/home_icon2.png"),
      "alt": "TOP Transfers",
      "title": ""
    }
  })]), _vm._v(" "), _c('b', [_vm._v("TOP Transfers")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://n.allfootballapp.com/v2/transfer?id=3"
    }
  }, [_c('p', [_c('span', {
    staticClass: "rumour"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home/home_icon3.png"),
      "alt": "Transfers Rumours",
      "title": ""
    }
  })]), _c('b', [_vm._v("Rumours")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2622e9a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transferEntrance.vue
// module id = 575
// module chunks = 4 5